import React from "react";
import { YhBox } from "@/components/YhBox";
import { SearchItem } from "@/components/YhPageHeader/item";
import { Row } from "antd";
import { ISearchField, ISearchProp, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { useDetailModel } from "../detailModel";
import { useBillModel } from "./billModel";
import { billStatusDs, ioFlagDs, billCancelStatusDs } from "@/types/FmsDs";
import useGlobalModel from "@/model/globalModel";

export const BIllSearchBox = () => {
    const { user: { shopId }, userBranch } = useGlobalModel();

    const {
        orgDs,
        beDs
    } = useDetailModel(model => [model.orgDs, model.beDs]);
    const {
        onSearch,
        searchParam,
        onReset,
        updateSearchParam,
        loadData
    } = useBillModel()
    const { accountTypeDs, tradeTypeDs } = useGlobalModel()


    const searchProp: ISearchProp = {
        searchValues: searchParam,
        triggerSearch: true,
        handleSearch: (val:any = {}) => {
            if(val.time){
                let newData = {
                    billTimeRange: val.time[0] !== '' && val.time[1] !== '' ? {
                        startTime: val.time[0] + ' 00:00:00',
                        endTime: val.time[1] + ' 23:59:59'
                    } : undefined,
                    ...val
                }
                updateSearchParam(newData)
                loadData({ pageNum: 1 }, { ...searchParam, ...newData })
            }else if(val.createTime ){
                let newData = {
                    ...val,
                    createOrderTimeStart:val.createTime? val.createTime[0].split('-').join(''):null,
                    createOrderTimeEnd:val.createTime? val.createTime[1].split('-').join(''):null,
                }
                updateSearchParam(newData)
                loadData({ pageNum: 1 }, { ...searchParam, ...newData })
            }
            else{
                updateSearchParam(val)
                loadData({ pageNum: 1 }, { ...searchParam, ...val })
            }
            },
        onChange: (data) => {
            if(data.time){
                let newData = {
                    billTimeRange: data.time[0] !== '' && data.time[1] !== '' ? {
                        startTime: data.time[0] + ' 00:00:00',
                        endTime: data.time[1] + ' 23:59:59'
                    } : undefined,
                    ...data
                }
                updateSearchParam(newData)
            }else if(data.createTime ){
                let newData = {
                    ...data,
                    createOrderTimeStart:data.createTime? data.createTime[0].split('-').join(''):null,
                    createOrderTimeEnd:data.createTime? data.createTime[1].split('-').join(''):null,
                }
                updateSearchParam(newData)
            }
            else{
                updateSearchParam(data)
            }
        }
    }
    const searchFields: any = [
        {
            type: SearchTypeEnum.TreeSelect,
            xxl: 4,
            span: 4,
            placeholder: "机构",
            fieldName: "orgCode",
            size: "small",
            disabled: false,
            treeDs: orgDs,
            ...searchProp
        },
        {
            type: SearchTypeEnum.Select,
            xxl: 3,
            span: 3,
            placeholder: "实体",
            fieldName: "beCode",
            size: "small",
            disabled: false,
            options: beDs,
            ...searchProp
        },
        {
            type: SearchTypeEnum.Select,
            xxl: 3,
            span: 3,
            placeholder: "单据类型",
            fieldName: "tradeTypeCode",
            size: "small",
            disabled: false,
            options: tradeTypeDs,
            ...searchProp
        },
        {
            type: SearchTypeEnum.Select,
            xxl: 3,
            span: 3,
            placeholder: "账户类型",
            fieldName: "accountTypeCode",
            size: "small",
            options: accountTypeDs,
            ...searchProp
        },
        {
            type: SearchTypeEnum.Input,
            xxl: 3,
            span: 3,
            placeholder: "账单编码",
            fieldName: "code",
            size: "small",
            disabled: false,
            ...searchProp
        },
        {
            type: SearchTypeEnum.Select,
            xxl: 3,
            span: 3,
            placeholder: "收支类型",
            fieldName: "ioFlag",
            size: "small",
            disabled: false,
            options: ioFlagDs,
            ...searchProp
        },
        {
            type: SearchTypeEnum.Button,
            xxl: 2,
            span: 2,
            placeholder: "检索",
            fieldName: "searchButton",
            onClick: onSearch,
        },
        {
            type: SearchTypeEnum.Button,
            xxl: 2,
            span: 2,
            placeholder: "重置",
            fieldName: "searchButton",
            onClick: onReset
        },
        {
            type: SearchTypeEnum.RangePicker,
            xxl: 7,
            span: 7,
            placeholder: "起止",
            fieldName: "time",
            size: "small",
            disabled: false,
            ...searchProp,
            // onChange: (data) => {
            //     let newData = {
            //         billTimeRange: data.time[0] !== '' && data.time[1] !== '' ? {
            //             startTime: data.time[0] + ' 00:00:00',
            //             endTime: data.time[1] + ' 23:59:59'
            //         } : undefined,
            //         ...data
            //     }
            //     updateSearchParam(newData)
            //     loadData({ pageNum: 1 }, { ...searchParam, ...newData })
            // }
        },
        ...((str) => {
            if (str) {
                return [
                    {
                        type: SearchTypeEnum.RangePicker,
                        xxl: 6,
                        span: 6,
                        size: "small",
                        disabled: false,
                        fieldName: "createTime",
                        rangePickerFieldName: ["createOrderTimeStart", "createOrderTimeEnd"],
                        placeholder: ["制单起始日期", "制单结束日期"],
                        format: "YYYY-MM-DD",
                        ...searchProp,
                        // onChange: (data) => {
                        //     let newData = {
                        //         ...data,
                        //         createOrderTimeStart:data.createTime? data.createTime[0].split('-').join(''):null,
                        //         createOrderTimeEnd:data.createTime? data.createTime[1].split('-').join(''):null,
                        //     }
                        //     updateSearchParam(newData)
                        //     loadData({ pageNum: 1 }, { ...searchParam, ...newData })
                        // }
                    },
                ]
            } else {
                return []
            }
        })(userBranch === 'ci'),
        {
            type: SearchTypeEnum.Select,
            xxl: 3,
            span: 3,
            placeholder: "收款状态",
            fieldName: "status",
            size: "small",
            disabled: false,
            options: billStatusDs,
            ...searchProp
        },
        {
            type: SearchTypeEnum.Select,
            xxl: 3,
            span: 3,
            placeholder: "取消状态",
            fieldName: "cancelStatus",
            size: "small",
            disabled: false,
            options: billCancelStatusDs,
            ...searchProp
        },
        {
            type: SearchTypeEnum.Input,
            xxl: 3,
            span: 3,
            placeholder: "单据编号",
            fieldName: "tradeCode",
            size: "small",
            disabled: false,
            ...searchProp
        }
    ]

    return (
        <YhBox>
            <Row
                gutter={[20, 10]}
                justify="start"
                style={{ padding: "0 15px" }}
            >
                {searchFields?.map(
                    (el:any, index:any) => <SearchItem
                        key={index}
                        {...el} />
                )}
            </Row>
        </YhBox>
    )
}
